import React from "react";
import { Typography } from "@mui/material";
import SectionCard from "./SectionCard";

const EmptyState = ({
  title = "Nothing to show",
  description,
  className,
  sx,
  ...props
}) => {
  return (
    <SectionCard className={className} sx={sx} {...props}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      ) : null}
    </SectionCard>
  );
};

export default EmptyState;
